import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import MenuStyles from "components/menu/Menu.module.scss";
import { UserCard } from "components/menu/UserCard";
import { JewelInfo } from "components/menu/JewelInfo";
import { ToSite } from "components/menu/ToSite";
import { BoxStatus } from "components/menu/BoxStatus";
import { SpotifyButton } from "components/menu/SpotifyButton";
import { MenuBody, NewMenuBody } from "components/menu/MenuBody";
import { MenuFoot } from "components/menu/MenuFoot";
import { MenuFootGp } from "components/menu/MenuFootGp";

import ToggleMenuMobile from "components/text/ToggleMenuMobile";
import { UiActions } from "state/actions/UiActions";
import { Portal } from "components/general/Portal";
import { GlamboxSessionStore } from "core/glambox/GlamboxSessionStore";
import { showPortalGp } from "core/utils/SubscriberUtils";

export class Menu extends Component {
  isGp = this.props.person.person.personStatus === 14;

  menuComponents = [
    {
      component: showPortalGp() ? null : ToSite,
      showOnMobile: true,
    },
    {
      component: UserCard,
      showOnMobile: false,
    },
    {
      component: this.isGp ? null : JewelInfo,
      showOnMobile: true,
    },
    {
      component: BoxStatus,
      showOnMobile: true,
    },
    /*{
      component: SpotifyButton,
      showOnMobile: true
    },*/
    {
      component: () => {
        return <NewMenuBody className={MenuStyles["menu"]} />;
      },
      showOnMobile: true,
    },
    // {
    //   component: MenuBody,
    //   showOnMobile: true
    // },
    {
      component: showPortalGp() ? MenuFootGp : MenuFoot,
      showOnMobile: true,
    },
  ];

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      subscriber: false,
    };

    this.menuHide = this.menuHide.bind(this);
  }

  menuHide() {
    this.props.hideMenu();
  }

  renderMenuBlocks() {
    return this.menuComponents.map((item, key) => {
      if (!item.component) return null;

      let Curr = item.component;

      if (this.props.ui.mobile === true && false === item.showOnMobile) {
        return null;
      }

      return <Curr key={key} person={this.props.person} />;
    });
  }

  componentDidMount() {}

  render() {
    const { props } = this;

    if (props.person === null) return null;

    if (props.ui.mobile === true || window.innerWidth < 720) {
      let _cls = [MenuStyles["menu-mobile__wrap"]];
      if (props.ui.menu.visible === true) {
        _cls.push(MenuStyles["show"]);
      }

      return (
        <div className={MenuStyles["gb-menu-fixed"]}>
          <UserCard mobile />

          <Portal id={"gb-menu-mobile"} className={classnames(_cls)}>
            <div className={MenuStyles["gb-menu-mobile__body"]}>
              {this.renderMenuBlocks()}
            </div>

            <div
              className={MenuStyles["gb-menu-mobile__overlay"]}
              onClick={this.menuHide}
            />
          </Portal>
        </div>
      );
    }

    return <div id={"gb-menu"}>{this.renderMenuBlocks()}</div>;
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  person: state.person.data,
});

const mapDispatchToProps = (dispatch) => ({
  hideMenu: () => {
    dispatch(UiActions.menuHide());
  },
});

Menu = connect(mapStateToProps, mapDispatchToProps)(Menu);
